import { Chip, ChipProps, Box, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";

interface ThemeOptions {
  size?: "small" | "medium";
}

const useStyles = makeStyles<Theme, ThemeOptions>((theme) => ({
  chip: {
    fontWeight: 500,
    height: ({ size }) => (size === "medium" ? 20 : 16),
    fontSize: ({ size }) => (size === "medium" ? 12 : 11),
    marginLeft: theme.spacing(1),
  },
}));

export interface NewChipProps {
  children: React.ReactNode;
  chipProps?: Omit<ChipProps, "label">;
  label?: string;
}

const NewChip = (props: NewChipProps) => {
  const { children, chipProps, label = "New" } = props;
  const s = useStyles({ size: chipProps?.size || "medium" });

  return (
    <Box>
      {children}
      <Chip
        label={label}
        color="primary"
        size="small"
        {...chipProps}
        className={s.chip}
      />
    </Box>
  );
};

export default NewChip;
